module.exports = __webpack_public_path__ + "static/media/hk.df295e86.svg";